import { ColumnOptionsStateKey } from './column-options-state-key.model';
import { ColumnOptionsStatePreference } from '@shared-features/models/column-options-state-preference.model';
import { Expose, Type } from 'class-transformer';
import { Model } from '@shared-features/models/model';

export class ColumnOptionsState extends Model {
  @Expose()
  id: string;

  @Expose()
  keys: any;

  @Expose()
  @Type(() => ColumnOptionsStateKey)
  state: ColumnOptionsStateKey[];

  @Expose()
  @Type(() => ColumnOptionsStateKey)
  defaultState?: ColumnOptionsStateKey[];

  @Expose()
  @Type(() => ColumnOptionsStatePreference)
  preferences: ColumnOptionsStatePreference[];

  /**
   * Mandatory columns for this list: not removable, not reorderable.
   *
   * Carried on the state rather than as a panel @Input because the panel is a single instance in the
   * layout and has no per-page binding site. Absent for every pre-existing list, which is why they
   * are unaffected.
   */
  @Expose()
  lockedKeys?: string[];

  /**
   * The arrangement this list's Reset restores.
   *
   * Named `resetState`, NOT `defaultState` (deviation D-1): `defaultState` above already means "the
   * initial state, used as a fallback". Reusing that name would make Reset restore the wrong columns.
   */
  @Expose()
  @Type(() => ColumnOptionsStateKey)
  resetState?: ColumnOptionsStateKey[];

  /** Hides the "Apply my column settings" / custom-preferences block for lists that do not use it. */
  @Expose()
  hideCustomColumnSettings?: boolean;

  /** Hides the "Show dynamic fields" section for lists that manage dynamic fields as real columns. */
  @Expose()
  hideDynamicFieldsToggle?: boolean;

  /**
   * Labels to render VERBATIM, keyed by column key.
   *
   * A column listed here skips `'Reports.' + suffix | translate` entirely. That is required for a
   * column whose name is data the user typed - a customer dynamic field - because there is no
   * translation key to look up, so the lookup would render the missing key itself.
   *
   * Absent for every pre-existing list, so they all stay fully translated.
   */
  @Expose()
  rawLabels?: Record<string, string>;
}
